import './app/index.css';
import ReactDOM from 'react-dom/client';

import { App } from './app';

// @ts-ignore
BigInt.prototype['toJSON'] = function () {
  return this.toString();
};

ReactDOM.createRoot(document.getElementById('pactswap')!).render(<App />);
